import React from "react";

// Componente Cartao com dados fake
const Cartao = ({ cartao }) => {
  const fakeCartao = {
    numero: "1234 5678 9012 3456",
    nome: "Fulano da Silva",
    validade: "12/2028",
    cvv: "123",
  };

  const data = cartao || fakeCartao;

  return (
    <div className="bg-white w-[80%] md:w-[90%] mx-auto mt-12 h-[35vh] flex flex-row rounded-lg border-solid border-2 border-[#003D42] p-8">
      <div className="flex flex-col justify-center ml-2 gap-0">
        {/* Número */}
        <div className="mt-[10px]">
          <p className="text-gray-500 text-sm">Número</p>
          <p className="text-gray-800 text-lg font-semibold min-h-[30px]">
            {data.numero || ""}
          </p>
        </div>

        {/* Nome */}
        <div className="mt-[-10px]">
          <p className="text-gray-500 text-sm">Nome</p>
          <p className="text-gray-800 text-lg font-semibold min-h-[30px]">
            {data.nome || ""}
          </p>
        </div>

        {/* Validade e CVV */}
        <div className="flex flex-row mt-[-10px] gap-6">
          <div className="w-28"> {/* largura fixa para a validade */}
            <p className="text-gray-500 text-sm">Validade</p>
            <p className="text-gray-800 text-lg font-semibold min-h-[30px] truncate">
              {data.validade || ""}
            </p>
          </div>
          <div className="w-20"> {/* largura fixa para o CVV */}
            <p className="text-gray-500 text-sm">CVV</p>
            <p className="text-gray-800 text-lg font-semibold min-h-[30px]">
              {data.cvv || ""}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Cartao;
